(() => {
  const endpoint = 'https://api.frankfurter.dev/v1/latest?base=TRY&symbols=USD';
  const cacheKey = 'nfs-try-usd-rate-v1';
  const cacheDuration = 12 * 60 * 60 * 1000;
  let rateData;

  const loadRate = async () => {
    try {
      const cached = JSON.parse(localStorage.getItem(cacheKey) || 'null');
      if (cached && Number.isFinite(cached.rate) && Date.now() < cached.expiresAt) {
        return cached;
      }
    } catch (_) {
      // Continue with a fresh request when browser storage is unavailable.
    }

    const response = await fetch(endpoint, { cache: 'no-cache' });
    if (!response.ok) throw new Error('Exchange-rate request failed');

    const data = await response.json();
    const rate = Number(data.rates?.USD);
    if (!Number.isFinite(rate) || rate <= 0 || !data.date) {
      throw new Error('Exchange-rate response is invalid');
    }

    const result = { rate, date: data.date, expiresAt: Date.now() + cacheDuration };
    try {
      localStorage.setItem(cacheKey, JSON.stringify(result));
    } catch (_) {
      // The current page can still use the fetched rate without storage.
    }
    return result;
  };

  const formatUSD = (cents, rate) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format((cents / 100) * rate);

  const renderPrices = () => {
    if (!rateData) return;

    document.querySelectorAll('.nfs-approx-usd[data-try-min]').forEach((element) => {
      const min = Number(element.dataset.tryMin);
      const max = Number(element.dataset.tryMax);
      if (!Number.isFinite(min) || !Number.isFinite(max) || min <= 0 || max <= 0) {
        element.hidden = true;
        return;
      }

      const signature = `${min}:${max}:${rateData.rate}:${rateData.date}`;
      if (element.dataset.renderedSignature === signature) return;

      const minUSD = formatUSD(min, rateData.rate);
      const maxUSD = formatUSD(max, rateData.rate);
      const value = min === max ? minUSD : `${minUSD}-${maxUSD}`;

      element.textContent = `${element.dataset.approxLabel} ${value}`;
      element.dataset.renderedSignature = signature;
      element.hidden = false;
    });
  };

  const start = async () => {
    const observer = new MutationObserver(renderPrices);
    observer.observe(document.documentElement, { childList: true, subtree: true });

    try {
      rateData = await loadRate();
      renderPrices();
    } catch (_) {
      document.documentElement.dataset.usdApproxUnavailable = 'true';
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();